export const localRouter_meun_tz = [
    // 投资动态
    {
        code: "T",
        switch: true,
        name: "产业投资动态",
        oldtext: "产业投资动态",
        type: "tzdt",
        url: "/investment-clues3",
        open: true,
        icontype: "el-icon-view",
        children: [{
                code: "T-CXQYRZ",
                switch: true,
                name: "",
                oldtext: "创新企业融资",
                url: "/investment-clues3"
            },
            {
                code: "T-BGQYND",
                switch: true,
                name: "",
                oldtext: "上市公司投资",
                url: "/markenterprise"
            },
            {
                code: "T-LTQYND",
                switch: true,
                name: "",
                oldtext: "企业拿地投资",
                url: "/landenterprise"
            },
            {
                code: "T-HYTZDT",
                switch: true,
                name: "",
                oldtext: "产业资讯动态",
                url: "/industryInvestment"
            },
            {
                code: "C-QYTZCK",
                switch: true,
                name: "",
                oldtext: "企业投资窗口期",
                url: "/enterpriseInvestmentWindow"
            },
            {
                code: "C-CYTZCK",
                switch: true,
                name: "",
                oldtext: "产业投资窗口期",
                url: "/industryInvestmentWindow"
            },
            // {
            //     code: "B-CYZC",
            //     switch: true,
            //     name: "",
            //     oldtext: "产业政策监测",
            //     url: "/policylibrary"
            // },
        ],
    },
    {
        code: "R",
        switch: true,
        name: "研究报告库",
        oldtext: "研究报告库",
        type: "yjbg",
        url: "report",
        open: true,
        icontype: "el-icon-s-management",
        children: [ 
            {
                code: "R-WLCY",
                switch: true,
                name: "",
                oldtext: "未来产业",
                url: "/report?type="+'w0',
                reportId: 'w0',
            },{
                code: "R-SZJJ",
                switch: true,
                name: "",
                oldtext: "数字经济",
                url: "/report?type=10005",
                reportId: 10005,
            },
            {
                code: "R-GDZZ",
                switch: true,
                name: "",
                oldtext: "高端制造",
                url: "/report?type=10014",
                reportId: 10014,
            },
            {
                code: "R-NYHBCL",
                switch: true,
                name: "",
                oldtext: "能源环保材料",
                url: "/report?type=10024",
                reportId: 10024,
            },
            // {
            //     code: "R-DJK",
            //     switch: true,
            //     name: "",
            //     oldtext: "大健康",
            //     url: "/report?type=10001",
            //     reportId: 10001,
            // },
            {
                code: "R-XDFWY",
                switch: true,
                name: "",
                oldtext: "现代服务业",
                url: "/report?type=10018",
                reportId: 10018,
            },
            {
                code: "R-DXF",
                switch: true,
                name: "",
                oldtext: "大消费",
                url: "/report?type=10029",
                reportId:10029 ,
            },
            {
                code: "R-JJYTZ",
                switch: true,
                name: "",
                oldtext: "基建与投资",
                url: "/report?type=10034",
                reportId: 10034,
            },
            {
                code: "R-DJK",
                switch: true,
                name: "",
                oldtext: "大健康",
                url: "/report?type=10001",
                reportId: 10001,
            },
            // {
            //     code: "R-BGQK",
            //     switch: true,
            //     name: "",
            //     oldtext: "报告全库",
            //     url: "report",
            //     newType: "VIP"
            // },
            {
                code: "R-BGQK",
                switch: true,
                name: "",
                oldtext: "报告全库",
                url: "report",
                newType: "VIP"
            },
            {
                code: "R-QYTZDTBG",
                switch: true,
                name: "",
                oldtext: "企业投资动态报告",
                url: "freeReport",
                reportId: 10006, 
            },
            {code:"R-TZDTYB",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
        ],
    },
    //产业研究 园区招商智能推荐为新增页面 默认为true
    {
        code: "B",
        switch: true,
        name: "产业研究工具",
        oldtext: "产业研究工具",
        url: "/localChainList",
        open: true,
        icontype: "el-icon-tickets",
        children: [
            {
                code: "L-SZJJ",
                switch: true,
                name: "",
                oldtext: "数字经济",
                url: "/allchain?type=10561"
            },
            {
                code: "L-GDZZ",
                switch: true,
                name: "",
                oldtext: "高端制造",
                url: "/allchain?type=10562"
            },
            {
                code: "L-NYHBCL",
                switch: true,
                name: "",
                oldtext: "能源环保材料",
                url: "/allchain?type=10563"
            },
            {
                code: "L-DJK",
                switch: true,
                name: "",
                oldtext: "大健康",
                url: "/allchain?type=10560"
            },
            {
                code: "L-XDFWY",
                switch: true,
                name: "",
                oldtext: "现代服务业",
                url: "/allchain?type=10637"
            },
            {
                code: "L-DXF",
                switch: true,
                name: "",
                oldtext: "大消费",
                url: "/allchain?type=10644"
            },
            {
                code: "B-DDTP",
                switch: false,
                switch: true,
                name: "",
                oldtext: "本地产业图谱",
                url: "/localChainList"
            },
            {
                code: "B-CYSJK",
                switch: true,
                name: "产业数据库",
                oldtext: "产业数据库",
                url: "/industryLibrary",
                newType:"NEW"
            },
            // {
            //     code: "B-QGTP",
            //     switch: true,
            //     name: "",
            //     oldtext: "全国产业图谱",
            //     url: "/allchain"
            // },
            {
                code: "B-TZXMK",
                switch: true,
                name: "",
                oldtext: "上市公司投资项目库",
                url: "invest"
            },
            {
                code: "B-NDXMK",
                switch: true,
                name: "",
                oldtext: "企业拿地投资项目库",
                url: "land"
            },
            
        ]
    },
    //投资大脑 企业对标研究 为新增页面 默认为true
    {
        code: "DB",
        switch: true,
        name: "企业对标研究",
        oldtext: "企业对标研究",
        type: "qydbyj",
        url: "/markingEnterpriseist?type=9",
        open: true,
        icontype: "el-icon-menu",
        children: [{
                code: "DB-SSGS",
                switch: true,
                name: "",
                oldtext: "上市公司",
                url: "/markingEnterpriseist?type=9"
            },
            {
                code: "DB-LTQY",
                switch: true,
                name: "",
                oldtext: "龙头企业",
                url: "/markingEnterpriseist?type=1"
            },
            {
                code: "DB-NZQY",
                switch: true,
                name: "",
                oldtext: "全部内资企业",
                url: "/markingEnterpriseist?type=0"
            },
            {
                code: "A-WZQY",
                switch: true,
                name: "",
                oldtext: "外资企业",
                url: "/forcapEnterprise"
            },
            {
                code: "A-JWSSQY",
                switch: true,
                name: "",
                oldtext: "境外上市企业",
                url: "/foreignEnterprises"
            },
            {
                code: "A-ZSDT",
                switch: true,
                name: "",
                oldtext: "数字地图",
                url: "/enterprise-mapsearch"
            },
        ]
    },
    //投资大脑 投资标的库 为新增页面 默认为true
    {
        code: "A",
        switch: true,
        name: "投资标的库",
        oldtext: "投资标的库",
        type: "tzbd",
        url: "/enterpriseList?type=2&t=1",
        open: true,
        icontype: "el-icon-menu",
        children: [{
                code: "A-CXQY",
                switch: true,
                name: "",
                oldtext: "创新企业库",
                url: "/enterpriseList?type=2&t=2"
            },
            {
                code: "A-YZQY",
                switch: true,
                name: "",
                oldtext: "优质企业库",
                url: "/enterpriseList?type=3&t=2"
            },
            // {code:"A-QBNZQY",switch:true,name:"",oldtext:"全部内资企业库",url:"/totalEnterprises"},
            // {code:"A-WZQY",switch:true,name:"",oldtext:"外资企业库",url:"/forcapEnterprise"},
            // {code:"A-JWSSQY",switch:true,name:"",oldtext:"境外上市企业库",url:"/foreignEnterprises"},	
        ]
    },
    // 智能推荐
    {
        code: "C",
        switch: true,
        name: "智能推荐",
        oldtext: "智能推荐",
        url: "/recommendation",
        open: true,
        morebtn: false,
        icontype: "el-icon-s-opportunity",
        children: [{
                code: "C-CYLZSXS",
                switch: true,
                name: "",
                oldtext: "产业投资推荐",
                url: "/recommendation"
            },
            // {code:"C-YZQYTJ",switch:true,name:"",oldtext:"优质企业推荐",url:"/intelligentRecommendation?type=3"},  
            // {code:"C-ZYJGTJ",switch:true,name:"",oldtext:"专业机构推荐",url:"/intelligentRecommendation?type=6"},
            // {code:"C-KYJGTJ",switch:true,name:"",oldtext:"科研机构推荐",url:"/intelligentRecommendation?type=7"},
            {
                code: "C-ZDQYQYPH",
                switch: true,
                name: "",
                oldtext: "区域企业推荐",
                url: "/investment-clues1"
            },
            {
                code: "C-YQQYTJ",
                switch: true,
                name: "",
                oldtext: "园区企业推荐",
                url: "/industrialpark" 
            },
        ]
    },
    //关系计算器 因为两个板块名字相似会导致冲突所以额外命名一个板块code 后台无法控制隐藏展示的 前端写死展示
    {
        code: "E",
        switch: true,
        name: "",
        oldtext: "关系计算器",
        url: "/enterprisesCityRelation",
        openicon: true,
        open: false,
        morebtn: false,
        icontype: "el-icon-s-platform",
        children: [{
                code: "E-QY－CSGXJSQ",
                switch: false,
                name: "",
                oldtext: "企业-城市 关系计算器",
                url: "/enterprisesCityRelation",
                newType: "HOT",
            },
            {
                code: "E-GXJSQ",
                switch: false,   
                name: "",
                oldtext: "企业-企业 关系计算器",
                url: "/relationalcalculator",
            },

            {
                code: "E-ZZDT",
                switch: false,
                name: "",
                oldtext: "投资地图",
                url: "/targetMap",
            },
            {
                code: "E-WDGXW",
                switch: true,
                name: "",
                oldtext: "我的关系网",
                url: "/userrelational"
            },
        ]
    },

    //工作台
    {
        code: "E",
        switch: true,
        name: "",
        oldtext: "工作台",
        url: "/workbench",
        open: false,
        openicon: true,
        morebtn: false,
        icontype: "el-icon-s-cooperation",
        children: [{
                code: "E-MBQY",
                switch: true,
                name: "",
                oldtext: "投资标的",
                url: "/focusenterprises"
            },
            {
                    code: "E-DBQY",
                    switch: true,
                    name: "",
                    oldtext: "企业对比",
                    url: "/enterprise-compare",
                    newType:'NEW',
                },
            {
                code: "E-TJFX",
                switch: true,
                name: "",
                oldtext: "统计分析",
                url: "/statisticalAnalysis"
            },
            {
                code: "E-XMGL",
                switch: true,
                name: "",
                oldtext: "项目管理",
                url: "/projectmanagement"
            },
            {
                code: "E-GJJL",
                switch: true,
                name: "",
                oldtext: "跟进记录",
                url: "/followuprecord"
            },
            {
                code: "E-DBJL",
                switch: true,
                name: "",
                oldtext: "待办记录",
                url: "/todolist"
            },
        ]
    },
    // {code:"E-XTGL",switch:false,name:"",oldtext:"系统管理",url:"/systemManagement"}, 在前端默认隐藏系统管理  具体原因不记得了 
    //个人中心
    {
        code: "F",
        switch: true,
        name: "",
        oldtext: "个人中心",
        url: "/baseInformation",
        open: false,
        openicon: true,
        morebtn: false,
        icontype: "el-icon-s-custom",
        children: [{
                code: "F-GZLY",
                switch: true,
                name: "",
                oldtext: "关注领域",
                url: "/userFocus"
            },
            {
                code: "F-JBZL",
                switch: true,
                name: "",
                oldtext: "基本资料",
                url: "/baseInformation"
            },
            {
                code: "F-MMXG",
                switch: true,
                name: "",
                oldtext: "密码修改",
                url: "/editPassword"
            },
            {
                code: "F-TCZH",
                switch: true,
                name: "",
                oldtext: "退出账号",
                url: "loginout"
            },
        ]
    },
]